import React from 'react';
import { Link } from 'react-router-dom';
import './business.css';

const Business = () => {
    const businessList = [
        {
            title: 'LED 전광판 렌탈',
            description: '행사 규모와 시청 거리를 고려한 LED 전광판 구성 및 설치',
            image: '/images/business/service3.png'
        },
        {
            title: '빔프로젝터 렌탈',
            description: '공간과 조명 환경에 적합한 프로젝터와 스크린 구성',
            image: '/images/business/service4.png'
        },
        {
            title: '행사 · 전시 영상 운영',
            description: '기업행사, 전시회, 세미나, 공연 등 목적에 맞춘 영상 시스템 운영',
            image: '/images/business/service2.png'
        },
        {
            title: '설치 · 현장 지원',
            description: '장비 설치부터 현장 세팅과 행사 운영까지 전문 인력이 지원',
            image: '/images/business/service1.png'
        }
    ];

    return (
        <section className="home-business-section">
            <div className="home-business-inner">
                <div className="home-business-intro">
                    <p className="home-business-label">
                        BUSINESS
                    </p>

                    <h2>
                        공간의 가치를 높이는
                        <br />
                        <strong>
                            전문 영상 솔루션
                        </strong>
                    </h2>

                    <p className="home-business-description">
                        엠티미디어는 LED 전광판 및 빔프로젝터 대여·렌탈·임대 전문기업입니다.
                        20년 이상의 현장 경험과 전문성을 바탕으로 행사 규모와 설치 환경에 최적화된 장비와 서비스를 제공하며,
                        고객의 신뢰와 만족을 최우선으로 안정적인 행사를 지원합니다.
                    </p>

                    <Link
                        to="/business"
                        className="home-business-more"
                    >
                        사업분야 자세히 보기
                        <span>
                            →
                        </span>
                    </Link>
                </div>

                <div className="home-business-list">
                    {businessList.map((item) => (
                        <div
                            className="home-business-card"
                            key={item.title}
                        >
                            <div className="home-business-image">
                                <img
                                    src={item.image}
                                    alt={item.title}
                                />
                            </div>

                            <div className="home-business-card-content">
                                <h3>
                                    {item.title}
                                </h3>

                                <p>
                                    {item.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Business;